import React from 'react'
import { css as hcss, keyframes } from '@emotion/css'

type Props = {
  height: number
  width: number
  bottom?: any
  top?: any
  left?: number
  right?: number
}

const GreenCircle: React.FC<Props> = ({
  width,
  height,
  top,
  bottom,
  left,
  right,
}) => {
  const dash = keyframes`
0% {
  stroke-dashoffset: 500;
}
50% {
  stroke-dashoffset: 0;
}
100% {
  stroke-dashoffset: 0;
}
`
  const greenCircle = hcss`
  ${bottom ? `bottom : ${bottom}px; ` : `top : ${top}px; `}
  ${left ? `left : ${left}px;` : `right : ${right}px; `}
  position : absolute; 
    width : ${width}px; 
    height : ${height}px ;

& path{
    stroke-dasharray: 500;
    stroke-dashoffset: 500;
    animation: ${dash} 2s forwards cubic-bezier(0.42, 0.0, 0.58, 1.0) infinite;
}
`
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 73.027 18.912"
        className={greenCircle}
      >
        <path
          d="M69,4,58.819,5.24l-6.956.5-4.549.147h-5.2L32.1,5.537s-8.1-.257-15.974-1.287c-3.2-.418-11.572-1.915-16.3-4.03a6.031,6.031,0,0,1-3.154-3.19,3.677,3.677,0,0,1-.133-1.373A3.219,3.219,0,0,1-2.3-6.362,17.486,17.486,0,0,1,5.156-9.594l3.718-.687s5.211-.712,7.689-.874c1.7-.207,4.89-.394,7.937-.551,3.884-.129,5.99-.452,11.583-.282,2.038.062,4.117.081,6.378.223a74.114,74.114,0,0,1,9.512.942c.9.13,6.469,1.13,8.48,1.7A12.159,12.159,0,0,1,63.938-7.5a3.9,3.9,0,0,1,1.82,2.248,3.275,3.275,0,0,1-.445,2.72A7.122,7.122,0,0,1,62.33-.25,45.748,45.748,0,0,1,50.735,2.272a55.555,55.555,0,0,1-8.08,0,23.422,23.422,0,0,0-3.09-.211"
          transform="translate(3.967 12.526)"
          fill="none"
          stroke="#53d69a"
          stroke-width="0.8"
          stroke-linecap="round"
        />
      </svg>
    </>
  )
}

export default GreenCircle
